import React from "react";
import moment from "moment";

import { Line as LineChart } from "react-chartjs-2";

import { MOMENT_SPANISH_LANG } from "../../../config/defaults";

moment.locale("es", MOMENT_SPANISH_LANG);

function ViewersByHour({ hours, type }) {
  const [chartData, setChartData] = React.useState({
    labels: [],
    datasets: [],
  });

  const [from, setFrom] = React.useState("");
  const [until, setUntil] = React.useState("");

  React.useEffect(() => {
    if (hours?.data && hours.data.length) {
      const tmpChartData = {
        labels: [],
        datasets: [
          {
            label: "Usuarios por " + (type === "MINUTES" ? "minuto" : "hora"),
            backgroundColor: "rgba(51, 7, 124, 0.6)",
            borderColor: "rgba(51, 7, 124, 1)",
            pointBackgroundColor: "rgba(51, 7, 124, 1)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgba(51, 7, 124, 1)",
            data: [],
          },
        ],
      };

      const { data, labels } = hours;

      tmpChartData.datasets[0].data = data;
      setChartData({ ...tmpChartData, labels });

      setFrom(moment(hours.labels[0]).format("MMMM DD"));
      setUntil(moment(hours.labels[hours.labels.length - 1]).format("MMMM DD"));
    }
  }, [hours, type]);

  const sameDay = from === until;

  return (
    <div className="card card-body card-dashboard-twentyone ht-xl-100p">
      <h6 className="card-title tx-14 mg-b-10">
        Espectadores por {type === "MINUTES" ? "minuto" : "hora"}
      </h6>
      <div className="media cnt-user-by-hour" style={{ flexWrap: "wrap" }}>
        <LineChart data={chartData} options={{}} />

        {hours.length > 0 && (
          <h6>
            {sameDay ? "En " : "Desde "}
            {from}
            {sameDay ? "" : " a "}
            {sameDay ? "" : until}
          </h6>
        )}
      </div>
    </div>
  );
}

export default ViewersByHour;
